import { useEffect, useState } from "react";
import axios from "axios";

export default function BlogEmails() {
  const [blogEmails, setBlogEmails] = useState({});
  const [loading, setLoading] = useState(true);
  const API_BASE = import.meta.env.VITE_API_BASE_URL;

  useEffect(() => {
    const fetchBlogEmails = async () => {
      try {
        const res = await axios.get(`${API_BASE}blogs/emails`);
        setBlogEmails(res.data);
      } catch (error) {
        console.error("Failed to fetch blog emails:", error);
      } finally {
        setLoading(false);
      }
    };
    fetchBlogEmails();
  }, []);

  if (loading) {
    return <p className="text-gray-500">Loading...</p>;
  }

  const entries = Object.entries(blogEmails);

  if (entries.length === 0) {
    return (
      <div>
        <h2 className="text-xl font-bold mb-4">Blog Emails</h2>
        <p className="text-gray-500">No blog data found.</p>
      </div>
    );
  }

  return (
    <div>
      <h2 className="text-xl font-bold mb-4">Blog Emails</h2>
      <div className="space-y-4">
        {entries.map(([title, emails]) => (
          <div key={title} className="bg-white rounded-lg shadow p-4">
            <h3 className="font-semibold text-lg text-blue-700 mb-2">
              {title}
              <span className="ml-2 text-sm text-gray-500 font-normal">
                ({emails.length} {emails.length === 1 ? "email" : "emails"})
              </span>
            </h3>
            {emails.length === 0 ? (
              <p className="text-gray-400 text-sm">No emails recorded.</p>
            ) : (
              <ul className="list-disc list-inside space-y-1">
                {emails.map((email, idx) => (
                  <li key={idx} className="text-gray-700 text-sm">{email}</li>
                ))}
              </ul>
            )}
          </div>
        ))}
      </div>
    </div>
  );
}
